<template>
    <sweet-modal
            ref="modal"
            @close="image = null"
    >
        <img :src="image" class="img-fluid" />
    </sweet-modal>
</template>

<script>
    import { SweetModal } from 'sweet-modal-vue';
    import { EventBus } from "../EventBus";

    export default {
        name: "ImageModal",
        components: {
            SweetModal,
        },
        data() {
            return {
                image: null
            }
        },
        mounted() {
            EventBus.$on('showImageModal', data => {
                this.image = data.url;
                this.$refs.modal.open();
            })
        },
        beforeDestroy() {
            EventBus.$off('showImageModal')
        }
    }
</script>

<style scoped>

</style>